import { ICreateQuoteFormSection, IGetAiMenuAndServicesInfoData } from "../../types/quoteFormTypes";
import { SectionTypeEnum } from "../../constants/enums";

export const transformAIResponse = (res: IGetAiMenuAndServicesInfoData) => {
	const menuSections: ICreateQuoteFormSection[] = [];
	let serviceInfoSection: ICreateQuoteFormSection = {
		sectionTitle: "Service Information",
		sectionType: SectionTypeEnum.SERVICE,
		content: "",
		displayOrder: 11,
		attachments: [],
	};
	Object.entries(res?.aiResponse || {})?.forEach(([key, data]) => {
		if (key === "service_information") {
			const serviceData = data as { service_type: string[]; inclusions: string[] };
			const serviceTypesList = serviceData?.service_type?.map((item) => ({
				type: "list-item",
				children: [{ text: item }],
			}));
			const inclusionsList = serviceData?.inclusions?.map((item) => ({
				type: "list-item",
				children: [{ text: item }],
			}));
			const richText = [
				{
					type: "bulleted-list",
					children: [...(serviceTypesList ?? []), ...(inclusionsList ?? [])],
				},
			];
			serviceInfoSection = { ...serviceInfoSection, content: JSON.stringify(richText) };
		} else {
			const contentArray = data as string[];
			const listItems = contentArray?.map((item) => ({
				type: "list-item",
				children: [{ text: item }],
			}));
			const richText = [
				{
					type: "bulleted-list",
					children: listItems,
				},
			];
			if (menuSections?.length < 10) {
				menuSections.push({
					sectionTitle: key?.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()),
					sectionType: SectionTypeEnum.MENU,
					content: JSON.stringify(richText),
					displayOrder: menuSections?.length + 1,
					attachments: [],
				});
			}
		}
	});
	return {
		serviceInfoSection,
		menuSections:
			menuSections?.length > 0
				? menuSections
				: [
						{
							sectionTitle: "Custom",
							sectionType: SectionTypeEnum.MENU,
							content: "",
							displayOrder: 1,
							attachments: [],
						},
					],
	};
};
